// acs补购功能页
import {

  WgtNewSlider,
  WgtHotZone,
  WgtHoriZontal,
  WgtblokScroll,
  WgtFilm,
  WgtAbtest,

  WgtStickyLift,
  WgtStoreRuleList,
  WgtTabsCut,
  WgtGoodsLift,
  WgtOldGoods,
  WgtOldEvaluate,
  WgtWallPaper,

  WgtAroundStoreOne,
  WgtFooterNav,
  WgtProductShelves,
  WgtCustomWgt,
  WgtLift,

  WgtContentPart,
  WgtImageText,
  WgtArticle,
  WgtClassify,
  WgtMemberInfo,
  WgtSuspension,
  WgtUserContainer,
  WgtOfficialAccount,
  WgtMemberTask

} from '../wgts/index'

export const initiWidgets = []

export const widgets = {

  WgtNewSlider,
  WgtHotZone,
  WgtHoriZontal,
  WgtblokScroll,
  WgtFilm,
  WgtAbtest,

  WgtStickyLift,
  WgtStoreRuleList,
  WgtTabsCut,
  WgtGoodsLift,
  WgtOldGoods,
  WgtOldEvaluate,
  WgtWallPaper,

  WgtAroundStoreOne,
  WgtFooterNav,
  WgtProductShelves,
  WgtCustomWgt,
  WgtLift,

  WgtContentPart,
  WgtImageText,
  WgtArticle,
  WgtClassify,
  WgtMemberInfo,
  WgtSuspension,
  WgtUserContainer,
  WgtOfficialAccount,
  WgtMemberTask
}


export default {
  widgets,
  initiWidgets
}
